import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";

export default {
    storageKey: StorageKey.report_cash_flow,
    getReportLabel: () => t`Cash Flow Statement`,
    getColumns: () => [],
};
